import React from "react";
import { IStyledSVGIconProps, StyledSVGIcon } from "./icon.style";

export const ResetPasswordIcon: React.FC<IStyledSVGIconProps> = (props) => {
  return (
    <StyledSVGIcon
      version="1.1"
      id="icons"
      xmlns="http://www.w3.org/2000/svg"
      xlinkHref="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      width="26.26" 
      height="21.337" 
      viewBox="0 0 26.26 21.337"
      style={{ enableBackground: "new 0 0 48 39" }}
      xmlSpace="preserve"
      {...props}
    >
      <g id="Group_454" data-name="Group 454" transform="translate(0 0)">
        <path id="Path_134" data-name="Path 134" d="M25.713,19.677H24.619V7.641A1.612,1.612,0,0,0,22.977,6H17.507V7.094h5.471a.517.517,0,0,1,.547.547V19.677H2.735V7.641a.517.517,0,0,1,.547-.547H8.753V6H3.282A1.612,1.612,0,0,0,1.641,7.641V19.677H.547A.517.517,0,0,0,0,20.224v1.094a2.709,2.709,0,0,0,2.735,2.735H23.524a2.709,2.709,0,0,0,2.735-2.735V20.224A.517.517,0,0,0,25.713,19.677Zm-.547,1.641a1.612,1.612,0,0,1-1.641,1.641H2.735a1.612,1.612,0,0,1-1.641-1.641v-.547H25.166Z" transform="translate(0 -2.716)" fill="#007bc3"/>
        <rect id="Rectangle_1113" data-name="Rectangle 1113" width="3.265" height="1.088" transform="translate(11.021 18.069)" fill="#007bc3"/>
        <path id="Path_135" data-name="Path 135" d="M13,7.111v6.565a1.1,1.1,0,0,0,1.094,1.094h9.847a1.1,1.1,0,0,0,1.094-1.094V7.111a1.1,1.1,0,0,0-1.094-1.094H22.847V3.555A3.716,3.716,0,0,0,19.018,0a3.716,3.716,0,0,0-3.83,3.556V6.017H14.094A1.1,1.1,0,0,0,13,7.111Zm3.282-3.556a2.62,2.62,0,0,1,2.735-2.462,2.62,2.62,0,0,1,2.735,2.462V6.017H16.282Z" transform="translate(-5.888 0.003)" fill="#007bc3"/>
      </g>
    </StyledSVGIcon>
  );
};
